import { render, staticRenderFns } from "./Editdash.vue?vue&type=template&id=3e3a6fd2"
import script from "./Editdash.vue?vue&type=script&lang=js"
export * from "./Editdash.vue?vue&type=script&lang=js"
import style0 from "./Editdash.vue?vue&type=style&index=0&id=3e3a6fd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports